module.exports = __webpack_public_path__ + "src/assets/img/ic03.f28225aa.svg";